/**
 * 🔐 Auth0 Provider for Coach Cedar
 * Wraps the entire app with Auth0 authentication
 */

import React from 'react';
import { Auth0Provider as Auth0ProviderSDK } from '@auth0/auth0-react';
import { auth0Config } from './auth0-config';

interface Auth0ProviderProps {
  children: React.ReactNode;
}

export const Auth0Provider: React.FC<Auth0ProviderProps> = ({ children }) => {
  const onRedirectCallback = (appState?: any) => {
    // CRITICAL: Don't auto-redirect! Let Auth0Callback component handle the flow
    // The Auth0Callback component will:
    // 1. Verify token with backend
    // 2. Create/update user in database  
    // 3. Route based on onboarding status
    console.log('🔄 Auth0 onRedirectCallback triggered, staying on /auth/callback for processing');
    console.log('🔍 AppState:', appState);
    
    // Stay on /auth/callback - let Auth0Callback component handle routing
    // No automatic redirect here!
  };

  return (
    <Auth0ProviderSDK
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: auth0Config.redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
        // Merge in additional authorization params from config
        ...auth0Config.authorizationParams,
      }}
      useRefreshTokens={auth0Config.useRefreshTokens}
      cacheLocation={auth0Config.cacheLocation}
      onRedirectCallback={onRedirectCallback}
      httpTimeoutInSeconds={auth0Config.httpTimeoutInSeconds}
    >
      {children}
    </Auth0ProviderSDK>
  );
};
